import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import withRouter from '../../hoc/withRouter';
import noPhoto from '../../assets/img/no_photo.png';
import { getArticle } from '../../actions/article';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor/index';
import { dateFormatUK } from '../../utils/commonFunctions';
import ArticleList from '../common/article/article-list';
import RedirectToLogin from '../common/redirect-to-login';
import ArticlesList from '../common/article/articles-list';

import constants from './constants';

import './style.css';
import Featured from './featured/index';

class ArticlePage extends Component {
  createArticleList = data => data.map(curr => ({
    id: curr.id.toString(),
    attributes: {
      ...curr
    }
  }));

  UNSAFE_componentWillMount() {
    const {
      edit, isAdmin, match, dispatch
    } = this.props;

    dispatch(getArticle(match.params.id));

    if (edit && isAdmin) {
      dispatch({ type: 'TOGGLE_EDIT_CONTENT', payLoad: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { match, dispatch } = this.props;

    if (nextProps.match.params.id !== match.params.id) {
      dispatch(getArticle(nextProps.match.params.id));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({ type: 'CLEAR_NEWS_ARTICLE' });
  }

  calculateTitleTextColor = (attributes) => {
    const { hasGoldTheme, hasSelectTheme } = this.props;

    if (!attributes) {
      if (hasGoldTheme || hasSelectTheme) {
        return '#fff';
      }

      return '#000';
    }

    const color = attributes['title-text-colour'];

    if ((hasGoldTheme || hasSelectTheme) && color === 'Black') {
      return '#fff';
    }

    if (!(hasGoldTheme || hasSelectTheme) && color === 'White') {
      return '#000';
    }

    return color;
  }

  render() {
    const {
      area, latestNews, article, meta, match, dispatch
    } = this.props;

    if (!article) {
      return <RedirectToLogin loginPath='/' requestedPath={window.location.pathname}/>;
    }

    let image = noPhoto;

    if (article.attributes && article.attributes.link.image != null) {
      // eslint-disable-next-line prefer-destructuring
      image = article.attributes.link.image;
    }

    let videoLink = null;

    if (article.attributes && article.attributes['video-link'] != null) {
      // eslint-disable-next-line prefer-destructuring
      videoLink = article.attributes['video-link'];
    }

    let gameLink = null;

    if (article.attributes && article.attributes['game-link'] != null) {
      // eslint-disable-next-line prefer-destructuring
      gameLink = article.attributes['game-link'];
    }

    const title = article.attributes
      ? article.attributes.title
      : '';
    const date = article.attributes
      ? dateFormatUK(article.attributes['display-from-date'])
      : '';
    const category = article.attributes
      ? article.attributes.category
      : { id: 0, name: '' };
    const renderDate = category.name.toLowerCase() !== 'about ignite' && category.name.toLowerCase() !== 'how to earn';

    const titleTextColor = this.calculateTitleTextColor(article.attributes);

    const linkedArticles = article.attributes
      ? article.attributes['linked-articles']
      : [];

    const mobileScreen = window.innerWidth <= 768 && window.innerHeight <= 1097;
    const isSmallMobileScreen = window.innerWidth <= 480;
    let videoIframeHeight = mobileScreen ? 200 : 360;
    let videoIframeWidth = mobileScreen ? 420 : 640;
    let gameIframeSize = mobileScreen ? 420 : 700;

    if (isSmallMobileScreen) {
      videoIframeHeight = 180;
      videoIframeWidth = 320;
      gameIframeSize = 320;
    }

    return (
      <Container fluid className="article">
        {(area === 'retailer' || area === 'pre_login') && (
          <div>
            <div className="user-inner-container">
              <Row>
                <div className="article-image-container-border">
                  <div className="article-image-container">
                    <img alt="Article" src={image}/>
                  </div>
                </div>
              </Row>
              <Row className="article-body">
                <Col md={(latestNews && latestNews.length > 0) ? 8 : 12} className="no-padding">
                  <h1 style={{ color: titleTextColor }}>{title}</h1>
                  {videoLink && videoLink !== 'null' && (
                  <iframe
                    allow="autoplay; fullscreen"
                    allowfullscreen=""
                    frameborder="0"
                    src={videoLink}
                    height={videoIframeHeight}
                    width={videoIframeWidth}
                  />
)}
                  {gameLink && gameLink !== 'null' && (
                  <iframe
                    frameborder="0"
                    scrolling="yes"
                    src={gameLink}
                    width={gameIframeSize}
                    height={gameIframeSize}
                  />
)}
                  {meta && (
                    <InlineCKEditor
                      activeClass="content-editor"
                      config={{
                        width: '100%',
                        height: '100%'
                      }}
                      contents={meta.contents.length ? meta.contents[0] : ''}
                      identifier={meta.contents.length ? meta.contents[0].identifier : ''}
                      onContentSaved={() => {
                        dispatch(getArticle(match.params.id));
                        dispatch({
                          type: 'TOGGLE_EDIT_CONTENT',
                          payLoad: false
                        });
                      }}
                    />
                  )}
                </Col>
                <Col md={4} className="no-padding">
                  {meta && meta['most-read-articles'] && meta['most-read-articles'].length > 0 && (
                    <div className="article-related">
                      <div className="article-title-container">
                        <h2 className="article-title-header">Most read</h2>
                      </div>
                      <ArticlesList articles={meta['most-read-articles']} />
                    </div>
                  )}
                  {meta && meta['featured-articles'] && meta['featured-articles'].length > 0 && (
                    <div className="article-related">
                      <div className="article-title-container">
                        <h2 className="article-title-header">Featured articles</h2>
                      </div>
                      <Featured articles={meta['featured-articles']} />
                    </div>
                  )}
                  {(linkedArticles && linkedArticles.length > 0) && (
                    <div className="article-related">
                      <div className="article-title-container">
                        <h2 className="article-title-header">Linked articles</h2>
                      </div>
                      <ArticlesList articles={linkedArticles} />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        )}
        {(area !== 'retailer' && area !== 'pre_login') && (
          <div>
            <Row>
              <Col lg={12}>
                <Col md={3} sm={5}>
                  <Row>
                    <img alt="Article" className="article-image" src={image}/>
                  </Row>
                </Col>
                <Col md={9} sm={7}>
                  <Row>
                    <h2 className="title">
                      {title}
                    </h2>
                  </Row>
                  <Row>
                    <span>
                      {renderDate && date}
                    </span>
                  </Row>
                </Col>
              </Col>
            </Row>
            <Row>
              <Col className="content-page" lg={12}>
                {this.props.meta && (
                  <InlineCKEditor
                    activeClass="content-editor"
                    config={{
                      width: '100%',
                      height: '100%'
                    }}
                    contents={meta.contents.length ? meta.contents[0] : ''}
                    identifier={meta.contents.length ? meta.contents[0].identifier : ''}
                    onContentSaved={() => {
                      dispatch(getArticle(match.params.id));
                      dispatch({
                        type: 'TOGGLE_EDIT_CONTENT',
                        payLoad: false
                      });
                    }}
                  />
                )}
              </Col>
            </Row>
            {(this.props.article.attributes && this.props.article.attributes['linked-articles'].length > 0) &&
            (!this.props.isAdmin && !this.props.isAdminRoute) && (
              <Row>
                <Col lg={12}>
                  <PageTitle ignoreForDoc>
                    Have you seen?
                  </PageTitle>
                </Col>
                <Col lg={12}>
                  <ArticleList articles={this.createArticleList(this.props.article.attributes['linked-articles'])} type={area}/>
                </Col>
              </Row>
            )}
          </div>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  article: state.article.article,
  meta: state.article.meta,
  latestNews: state.latestNews.latestNews.filter(article => (
    !constants.excludedCategoryIds.includes(article.attributes.category.id)
  )),
  isAdmin: state.viewConfig.isAdmin,
  isAdminRoute: ownProps.location.pathname.includes('admin'),
  edit: ownProps.location.pathname.includes('edit-content'),
  hasGoldTheme: state.viewConfig.profile.attributes['has-ignite-gold-outlet'],
  hasSelectTheme: state.viewConfig.profile.attributes['has-mini-chain-outlet']
});

export default withRouter(connect(mapStateToProps)(ArticlePage));
